export const debugLog = (area, message, data) => {
  if (data !== undefined) {
    console.log(`[GuffPuff Debug][${area}] ${message}`, data);
  } else {
    console.log(`[GuffPuff Debug][${area}] ${message}`);
  }
};

export const debugPremiumSnapshot = (area, users = []) => {
  const rows = users.slice(0, 10).map((user) => ({
    uid: user.uid,
    username: user.username,
    isActive: user.isActive,
    isPremium: user.isPremium,
    subscriptionType: user.subscriptionType,
    plan: user.plan,
    type: user.type,
    subscriptionExpiry: user.subscriptionExpiry,
  }));

  debugLog(area, 'premium snapshot', {
    totalUsers: users.length,
    isActiveTrue: users.filter((user) => user.isActive === true).length,
    subscriptionTypePremium: users.filter((user) => user.subscriptionType === 'premium').length,
    isPremiumTrue: users.filter((user) => user.isPremium === true).length,
    sample: rows,
  });
};
